//řezník -> reznik
export const prepareFileName = (str: string): string => {
  return str
    .normalize("NFD")
    .replace(/ /g, "_")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/([^\w_.-]+|\s+)/g, "")
    .replace(/^[-_.]+/, "");
};

//can not use dot
export const prepareFolderName = (str: string): string => {
  return str
    .normalize("NFD")
    .replace(/ /g, "_")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/([^\w_-]+|\s+)/g, "")
    .replace(/^[-_]+/, "");
};
